/**
 * KAYA RECOMMENDED FOR YOU
 * Handles tab switching and keyboard navigation.
 */
(function () {
  'use strict';

  class KayaRecommendedForYou {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-kaya-rfy-tab]'));
      this.panels = Array.from(section.querySelectorAll('[data-kaya-rfy-panel]'));

      if (this.tabs.length === 0) return;

      this._bindEvents();
    }

    _bindEvents() {
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          this._activateTab(tab);
        }.bind(this));
      }.bind(this));

      var tabList = this.section.querySelector('[role="tablist"]');
      if (tabList) {
        tabList.addEventListener('keydown', function (e) {
          this._handleKeydown(e);
        }.bind(this));
      }
    }

    _activateTab(tab, focus) {
      var index = parseInt(tab.dataset.kayaRfyTab, 10);

      this.tabs.forEach(function (t) {
        var isActive = t === tab;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach(function (panel) {
        var panelIndex = parseInt(panel.dataset.kayaRfyPanel, 10);
        if (panelIndex === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });

      if (focus !== false) {
        tab.focus({ preventScroll: true });
      }
    }

    _handleKeydown(e) {
      var currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex = -1;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          e.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          e.preventDefault();
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      if (newIndex >= 0 && this.tabs[newIndex]) {
        this._activateTab(this.tabs[newIndex]);
      }
    }
  }

  function initSections() {
    document.querySelectorAll('[data-kaya-rfy-section]').forEach(function (el) {
      if (!el._kayaRFY) {
        el._kayaRFY = new KayaRecommendedForYou(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-kaya-rfy-section]');
    if (section) {
      section._kayaRFY = new KayaRecommendedForYou(section);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[data-kaya-rfy-section]');
    if (!section) return;
    var blockId = e.detail.blockId;
    var tab = section.querySelector('[data-kaya-rfy-tab][data-block-id="' + blockId + '"]');
    if (tab && section._kayaRFY) {
      section._kayaRFY._activateTab(tab);
    }
  });
})();
